import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import {
  ContraventionQuestionModel,
  RadioQuestionModel,
  SelectQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { EmergencyBadgeCopy } from '../../../helper/textcopy/policies.text';
import { ReportsService } from '../../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'emergency-badge-policy',
  templateUrl: './emergency-badge.component.html',
})
export class EmergencyBadgeComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = EmergencyBadgeCopy;

  emergencyBadges = new RadioQuestionModel();
  contraventionsQuestion = new ContraventionQuestionModel();
  reconsider = new RadioQuestionModel();
  cancellation = new SelectQuestionModel();

  constructor(
    public global: Global,
    private reportsService: ReportsService,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setEmergencyBadgesQuestion();
    this.setContraventionsQuestion();
    this.setReconsiderQuestion();
    this.setCancellationSelectQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setEmergencyBadgesQuestion() {
    this.emergencyBadges.data = {
      title: this.textCopy.emergencyBadgeUseTitle,
      includeTitle: true,
      answers: [
        {
          text: 'Yes, we insist on their use',
          value: '0',
        },
        {
          text: "Yes, but we don't insist on their use",
          value: '1',
        },
        {
          text: 'No',
          value: '2',
        },
      ],
    };
  }
  onEmergencyBadgesSelected(answerValue) {
    this.emergencyBadges.valueSelected = answerValue;
  }

  setContraventionsQuestion() {
    this.contraventionsQuestion.options = [
      { value: 'y', text: 'Y' },
      { value: 'n', text: 'N' },
      { value: 'q', text: 'Q' },
    ];
  }
  onContraventionsQuestionSelected(answerValue) {
    this.contraventionsQuestion.valuesSelected = answerValue;
    this.contraventionsQuestion.valuesSelected = this.contraventionsQuestion.valuesSelected.slice();
  }

  setReconsiderQuestion() {
    this.reconsider = {
      data: {
        title: this.textCopy.reconsiderRadioTitle,
        includeTitle: true,
        beforeText: '',
        afterText: '',
        answers: [
          {
            text: 'yes',
            value: 'y',
          },
          {
            text: 'yes – provided it was displayed (even if it was wrongly displayed)',
            value: 'd',
          },
          {
            text: 'no',
            value: 'n',
          },
        ],
      },
      active: true,
      valueSelected: 'd',
    };
  }
  onReconsiderSelected(answerValue) {
    this.reconsider.valueSelected = answerValue;
  }

  setCancellationSelectQuestion() {
    this.cancellation = {
      data: {
        title: this.textCopy.cancellationsSelectTitle,
        includeTitle: true,
        answers: [
          {
            id: 0,
            value: '1',
          },
          {
            id: 1,
            value: '2',
          },
          {
            id: 2,
            value: '3',
          },
        ],
      },
      active: true,
      valueSelected: '1',
    };
  }
  onCancellationSelected(answerValue) {
    this.cancellation.valueSelected = answerValue;
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventionsQuestion.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`3_3_${contravention.id}`];
        this.contraventionsQuestion.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  setSelectedValues() {
    this.emergencyBadges.valueSelected = this.policiesAnswers['3_1'];
    this.setSelectedContraventions();
    this.reconsider.valueSelected = this.policiesAnswers['3_2'];
    this.cancellation.valueSelected = this.policiesAnswers['3_4'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '3_1', description: this.emergencyBadges.valueSelected },
      { id: '3_2', description: this.reconsider.valueSelected },
      { id: '3_4', description: this.cancellation.valueSelected },
    ];

    this.contraventionsQuestion.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `3_3_${contravention['id']}`, description: contravention['value'] });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
